import { useEffect, useState } from "react";
import { useSelector } from "react-redux";

const Pagination = ({
	setData,
	service,
	shouldUpdate,
	isDeleted,
	setHasData,
	setLoading,
	type,
	search,
	param,
}) => {
	const [totalPages, setTotalPages] = useState();
	const [page, setPage] = useState(1);
	const lang = useSelector((state) => state.auth.lang);

	useEffect(() => {
		setLoading(true);
		let params = {
			offset: (page - 1) * 10,
			limit: 10,
			...param,
		};
		if (!!search) params["search"] = search;

		service?.getList(type, params).then((res) => {
			if (res?.status === 200) {
				let response = res.data?.data;
				setData(response?.data);
				setTotalPages(response?.totalPages);
				if (response?.totalItems > 0) {
					setHasData(1);
				} else {
					setHasData(0);
				}
			}
			setLoading(false);
		});

		window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
	}, [page, shouldUpdate, search]);

	useEffect(() => {
		setPage(1);
	}, [isDeleted, shouldUpdate]);

	if (totalPages > 1) {
		return (
			<div className="pagination">
				<div className="filter-pagination p-3  d-flex">
					<button
						className="previous-button"
						onClick={() => {
							setPage((prev) => parseInt(prev) - 1);
						}}
						disabled={parseInt(page) === 1}>
						{lang === "en" ? (
							<i className="la la-angle-left"></i>
						) : (
							<i className="la la-angle-right"></i>
						)}
					</button>
					<div className="d-flex" style={{ gap: "5px" }}>
						{Array.from({ length: totalPages }, (_, index) => index + 1)?.map(
							(num) => {
								return (
									<p
										onClick={() => {
											setPage(num);
										}}
										style={{
											padding: "5px 10px",
											cursor: "pointer",
											color: parseInt(page) === parseInt(num) ? "#fff" : "",
											background:
												parseInt(page) === parseInt(num)
													? "var(--primary)"
													: "",
											borderRadius: "50%",
											lineHeight: "1",
										}}
										className="mb-0">
										{num}
									</p>
								);
							}
						)}
					</div>
					<button
						className="next-button"
						onClick={() => {
							setPage((prev) => parseInt(prev) + 1);
						}}
						disabled={parseInt(page) === totalPages}>
						{lang === "en" ? (
							<i className="la la-angle-right"></i>
						) : (
							<i className="la la-angle-left"></i>
						)}
					</button>
				</div>
			</div>
		);
	}
};

export default Pagination;
